<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'ViewProfile' }">Back</router-link>
      </div>
    </div>
      <div class="container-fluid ib-acquisition-bg">
        <div class="container ib-p-0">
          <form @submit.prevent="updateInfo()" id="bootstrapForm">
            <div class="container multistep-box box-custom-padding">
              <!-- flower for box -->
              <img class="img-fluid in-flower-for-box" alt="icon" :src="require('@/assets/images/flower-for-box.svg')" />
              <!-- flower for box -->
              <div class="row my-2 ib-default-align" style="min-height:12rem;">
                <div class="col-md-6 align-self-lg-start">
                  <div class="">
                    <div class='profile-upload-img' id="edit-profile-img" :style="{ backgroundImage: 'url(' + serverUser.avatar + ')' }">
                      <div class="hvr-profile-img"><input type="file" accept="image/*" class="upload w180" @change="readUrl($event)"></div>
                      <div class="fa">Upload Image</div>
                    </div>
                    <div v-if="errors.filter(x => x.field == 'avatar').length > 0">
                      <div class="d-block jbl-text-danger" style="margin-top: 15px;">
                        <small class="text-danger">{{errors.filter(x => x.field == 'avatar')[0].message}}</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 text-center text-sm-right">
                   <h1 class="login-title text-center text-sm-right" style="margin-top:0 !important;">Edit Profile</h1>
                  <h5 class="ib-login-text text-center text-sm-right" style="margin-bottom:30px !important;">Please Update Your Profile</h5>
                </div>
              </div>
              <div class="row pt-4 wow animate__animated animate__fadeInUp">
                <div class="col-md-6">
                  <div>
                    <div class="jbl-field-sign">
                    <label class="jbl-label-sign">First Name</label>
                    <input type="text" class="ib-login-input" name="first_name" v-model="user.first_name" placeholder="Oliver" pattern="[a-zA-Z ]+" title="Only Alphabets">
                  </div>

                  <div v-if="errors.filter(x => x.field == 'first_name').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'first_name')[0].message}}</small>
                    </div>
                  </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="jbl-field-sign">
                    <label class="jbl-label-sign">Last Name</label>
                    <input type="text" class="ib-login-input" name="last_name" v-model="user.last_name" placeholder="James" pattern="[a-zA-Z ]+" maxlength="15" title="Only Alphabets">
                  </div>

                  <div v-if="errors.filter(x => x.field == 'last_name').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'last_name')[0].message}}</small>
                    </div>
                  </div>
                </div>
<!--                <div class="col-md-6">-->
<!--                  <div class="jbl-field-sign">-->
<!--                    <label class="jbl-label-sign">Middle Name</label>-->
<!--                    <input type="text" class="ib-login-input" name="middle_name" v-model="user.middle_name" placeholder="Oliver" pattern="[a-zA-Z ]+" maxlength="15" title="Only Alphabets">-->
<!--                  </div>-->
<!--                </div>-->
              </div>
              <div class="row wow animate__animated animate__fadeInUp">
                <div class="col-md-6">
                  <div class="jbl-field-sign jbl-disabled">
                    <label class="jbl-label-sign">Username</label>
                    <input type="text" class="ib-login-input ib-not-allowed" name="username" :value="serverUser.username" disabled placeholder="Username" pattern="[a-zA-Z0-9]+" title="Only Alphabets And Numbers">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="jbl-field-sign">
                    <label class="jbl-label-sign">Email</label>
                    <input type="email" class="ib-login-input" name="email" v-model="user.email" @change="verifyEmail($event)" placeholder="Enter Email">
                  </div>

                  <div v-if="errors.filter(x => x.field == 'email').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'email')[0].message}}</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row wow animate__animated animate__fadeInUp">
                <div class="col-md-6">
                  <div class="jbl-field-sign">
                    <label class="jbl-label-sign">Mobile Number</label>
                    <input v-mask="'+92##########'" type="text" class="ib-login-input" v-model="user.mobile_no" @input="validateMobileNo($event)" placeholder="Enter Mobile Number"/>
                  </div>

                  <div v-if="errors.filter(x => x.field == 'mobile_no').length > 0">
                    <div class="d-block jbl-text-danger">
                      <small class="text-danger">{{errors.filter(x => x.field == 'mobile_no')[0].message}}</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ib-action-btns">
                <button type="submit" class="ib-btn-primary ib-btn-width mr-3">Update</button>
                <router-link :to="{ name: 'ViewProfile' }" class="ib-btn-outline ib-btn-width" style="display:inline-block;">Cancel</router-link>
              </div>
            </div>
          </form>
        </div>
      </div>
  </div>
</template>

<script>
  import VuePhoneNumberInput from 'vue-phone-number-input';
  import MaskedInput from 'vue-masked-input';
  import loading from '@/components/Loading/Loading';
  import { mapActions } from "vuex";
  import { mask } from 'vue-the-mask';

  export default {
    name: 'EditProfile',
    data() {
      return {
        showLoader: false,
        serverUser: {},
        user: {
          first_name: '',
          //middle_name: '',
          last_name: '',
          email: '',
          mobile_no: '',
          avatar: ""
        },
        errors: []
      }
    },
    directives: { mask },
    components: {
      loading,
      MaskedInput,
      VuePhoneNumberInput
    },
    created() {
      const self = this;
      self.serverUser = self.$store.getters.getUser;

      Object.entries(self.user).forEach(([key, value]) => {
        if (key != 'avatar') {
          self.user[key] = self.serverUser[key]
        }
      });
    },
    methods: {
      ...mapActions(["LogOut"]),
      verifyEmail(event) {
        const self = this;

        self.errors = [];
        let email = event.target.value;
        if(email == '') {
          return false;
        }

        const re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let result = re.test(String(email).toLowerCase());
        if(!result) {
          self.errors.push({
            field: 'email',
            message: 'Invalid Email'
          });
        }
      },
      readUrl(e) {
        const self = this;
        if(e.target.files.length > 0) {
          var file = e.target.files[0];
        } else {
          return false;
        }

        if(file['type'].split('/')[0] != 'image') {
          $toast.error('Only image files are accepted', { position: 'top-right' });
          return false;
        } else if (file.size > 5000000) {
          $toast.error('Upload file less than 5Mb', { position: 'top-right' });
          return false;
        }

        var reader = new FileReader();
        reader.onloadend = function() {
          document.getElementById('edit-profile-img').style.backgroundImage = "url(" + reader.result + ")";
        }

        if(file) {
          reader.readAsDataURL(file);
          self.user.avatar = file;
        }
      },
      validateMobileNo (event) {
        const self = this;
        let val = event.target.value;

        if(val != "") {
          const usingSplit = val.split('');
          let issue = false;

          let i = 0;
          for (i; i < 4; i++) {
            if(usingSplit[i] === '0') {
              issue = true;
              break;
            }
          }

          if (issue) {
            event.target.value = '+92';
            self.user.mobile_no = '+92';
          }
        }
      },
      async updateInfo() {
        const self = this;
        self.errors = [];

        Object.entries(self.user).forEach(([key, value]) => {
          if (key != 'middle_name' && key != 'avatar' && value == '') {
            self.errors.push({
              field: key,
              message: key + 'Required'
            });
          }
        });

        if(self.user.mobile_no.length < 13) {
          self.errors.push({
            field: 'mobile_no',
            message: 'Incorrect Mobile Number'
          });
        }

        if(self.errors.length > 0) {
          return  false;
        }

        let updated = [];
        var formData = new FormData();
        Object.entries(self.user).forEach(([key, value]) => {
          if (key == 'avatar' && value != '') {
            formData.append('avatar', self.user.avatar);
            updated.push(key);
          } else if (key == 'email') {
            if(self.user[key] != self.serverUser[key]) {
              formData.append(key, self.user[key]);
              updated.push(key);
            }
          } else if (key == 'mobile_no') {
            if(self.user[key] != self.serverUser[key]) {
              formData.append(key, self.user[key]);
              updated.push(key);
            }
          } else if (key != 'avatar' && key != 'email' && key != 'mobile_no') {
            formData.append(key, self.user[key]);
          }
        });

        self.showLoader = true;
        await axios.post('customer/profile/update', formData).then(function (resp) {
          if(resp.data.code == 200) {
            self.$store.commit('setUser', resp.data.data)
            if (updated.includes('email')) {
              self.LogOut().then((response) => {
                self.showLoader = false;
                self.$store.commit("resetState");
                $toast.success('Profile data updated, please login again', { position: 'top-right' });
                window.location.reload();
              }).catch((error) => {
                self.showLoader = false;
              });
            } else {
              self.showLoader = false;
              self.$router.push({ name: 'ViewProfile' });
              self.$root.$emit('updateUser');
            }
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      }
    }
  }
</script>

<style scoped>
  .jbl-field-sign {
    margin-bottom: .7rem !important;
  }
  @media (min-width:992px) {
    .box-custom-padding {
      padding: 30px 120px !important;
    }
  }
  @media(max-width:550px){
    .login-title {
      margin: 4rem 0rem 1rem !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Profile/Edit.vue